module.exports = __webpack_public_path__ + "static/img/bg_subordinate_header.9a6a7b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boss-home/bg_subordinate_header.png
// module id = httd
// module chunks = 1